import type { BookingsMap } from "../../hooks/bookingTypes";
import type { Booking } from "../../hooks/bookingTypes";
import css from "./SumBar.module.css";

/**
 * Summary bar (B.2 footer). Compact strip at the end of the grid — NOT
 * sticky, scrolls with content. Numeric counters use tabular-nums for
 * column alignment.
 */
export interface SumBarProps {
  bookings: BookingsMap;
  onReload?: () => void;
}

export function SumBar({ bookings, onReload }: SumBarProps) {
  const stats = computeStats(bookings);

  return (
    <div className={css.bar}>
      {/* B.2.6 composition: ОПЛАЧ · БЕЗ · ВСЕГО · ИГРОКОВ + SYNC.
          Leads are intentionally NOT surfaced in the summary; "Без оплаты"
          is abbreviated to "БЕЗ"; ВСЕГО = total bookings (paid + unpaid). */}
      <Cell label="Оплач." value={stats.paid} klass="g" />
      <Sep />
      <Cell label="Без" value={stats.unpaid} klass="o" />
      <Sep />
      <Cell label="Всего" value={stats.paid + stats.unpaid} klass="t" />
      <Sep />
      <Cell label="Игроки" value={stats.players} klass="t" />
      {onReload ? (
        <button type="button" className={css.sync} onClick={onReload} aria-label="Перезагрузить">
          ↻
        </button>
      ) : null}
    </div>
  );
}

function Cell({ label, value, klass }: { label: string; value: number; klass: "g" | "o" | "p" | "b" | "t" }) {
  return (
    <span className={css.cell}>
      <span className={css.l}>{label}</span>
      <span className={`${css.num} ${css[klass]}`}>{value}</span>
    </span>
  );
}

function Sep() {
  return <span className={css.sep} aria-hidden="true">·</span>;
}

interface Stats {
  paid: number;
  unpaid: number;
  leads: number;
  blocks: number;
  players: number;
}

function computeStats(map: BookingsMap): Stats {
  let paid = 0,
    unpaid = 0,
    leads = 0,
    blocks = 0,
    players = 0;
  for (const item of Object.values(map)) {
    if (item.type === "auto-block") continue;
    const b = item as Booking;
    if (b.type === "block") {
      blocks++;
      continue;
    }
    if (b.type === "lead") {
      leads++;
      continue;
    }
    if (b.prepaid) paid++;
    else unpaid++;
    players += b.players ?? 0;
  }
  return { paid, unpaid, leads, blocks, players };
}
